import React from 'react';
import { withStyles } from "@material-ui/core/styles";
import { Breadcrumbs, Link } from '@material-ui/core';
import { v4 as uuidv4 } from 'uuid';

const styles = theme => ({
    root: {
        // marginBottom: "16px",
        marginTop: "70px",
        maxWidth: "1000px",
        margin: "0px auto",
        padding: "0 30px",
        // border: "solid 20px #ee5029",
        '@media screen and (max-width: 1500px)': {
            marginTop: "70px",
        }
    },
    link: {
        textTransform: "capitalize",
        color: "black",
        fontSize: "13px",
        fontWeight: "100",
        // fontFamily: "sans serif"
    }
})


class HomeHeader extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            isLoaded: false,
            ...props
        };
    }

    // componentDidMount() {
    // PLACEHOLDER
    // }

    render() {
        const { classes } = this.props;
        return (
            <Breadcrumbs className={classes.root} aria-label="breadcrumb">
                {Object.keys(this.state.data).map((keyName, keyIndex, extra) => {
                    let slugClean0 = (this.state.data[0] !== undefined)? this.state.data[0].replace(/[/]/g, ' ').replace(' County', '').replace(/ /g, '').toLowerCase() : null;
                    let slugClean1 = (this.state.data[1] !== undefined)? this.state.data[1].replace(/[/]/g, ' ').replace(' County', '').replace(/ /g, '').toLowerCase() : null;
                    let slugClean2 = (this.state.data[2] !== undefined)? this.state.data[2].replace(/[/]/g, ' ').replace(' County', '').replace(/ /g, '').toLowerCase() : null;
                    let slugClean3 = (this.state.data[3] !== undefined)? this.state.data[3].replace(/[/]/g, ' ').replace(/ /g, '').toLowerCase() : null;
                    console.log(extra)
                    return (
                        <Link
                            className={classes.link}
                            key={uuidv4()}
                            href={(keyIndex === 0) ?
                                `/${slugClean0}/counties`
                                : (keyIndex === 1) ?
                                    `/${slugClean0}/${slugClean1.replace('.', '-')}/`
                                    : (keyIndex === 2) ?
                                        `/${slugClean0}/${slugClean1.replace('parks', 'park').replace('.', '-')}/${slugClean2.replace('.', '-')}/`
                                        :
                                        `/${slugClean0}/${slugClean1.replace('.', '-')}/${slugClean2.replace('.', '-')}/${slugClean3.replace('.', '-')}/`
                            }>
                            {this.state.data[keyIndex].replace(/[/]/g, ' ').replace(/-/g, ' ')}
                        </Link>
                    )
                })}
            </Breadcrumbs>
        )
    }
}
export default withStyles(styles, { withTheme: true })(HomeHeader);